import { UPDATE } from 'admin-on-rest'
import { dateNow } from '../util'

export const ACCOUNT_TRANSMIT = 'ACCOUNT_TRANSMIT'

const trackingDefaults = {
	from_status: '',
	to_status: '',
	event: '',
	date: '',
}

export const accountTransmit = (id, data, date = dateNow()) => {

	const tracking = [
		...(data.fields.tracking || []),
		{
			...trackingDefaults,
			from_status: data.fields.status || 'new',
			to_status: 'transmitted',
			date: date,
		}
	]

	return {
	    type: ACCOUNT_TRANSMIT,
		payload: { id, data: {
			...data,
			fields: {
				...data.fields,
				status: 'transmitted',
				is_transmitted: true,
				transmitted_date: date,
				release_or_paper_released_date: data.fields.release_or_paper_released_date || date,
				tracking,
				was_transmitted_pending_release: ! data.fields.is_released ? true : data.fields.was_transmitted_pending_release,
			},
		}},
	    meta: { resource: 'accounts', fetch: UPDATE, cancelPrevious: false },
	}
}

export const ACCOUNT_RELEASE = 'ACCOUNT_RELEASE'

export const accountRelease = (id, data, date = dateNow()) => {

	const tracking = [
		...(data.fields.tracking || []),
		{
			...trackingDefaults,
			event: 'release',
			date: date,
		}
	]

	return {
	    type: ACCOUNT_RELEASE,
		payload: { id, data: {
			...data,
			fields: {
				...data.fields,
				released_date: date,
				release_or_paper_released_date: data.fields.release_or_paper_released_date || date,
				is_released: true,
				tracking,
			},
		}},
	    meta: { resource: 'accounts', fetch: UPDATE, cancelPrevious: false },
	}
}

export const ACCOUNT_CONFIRM_TRANSMITTAL = 'ACCOUNT_CONFIRM_TRANSMITTAL'

export const accountConfirmTransmittal = (id, data, dateTime) => {

	const tracking = [
		...(data.fields.tracking || []),
		{
			...trackingDefaults,
			from_status: data.fields.status,
			to_status: 'review',
			date: dateTime,
		}
	]

	return {
	    type: ACCOUNT_CONFIRM_TRANSMITTAL,
		payload: { id, data: {
			...data,
			fields: {
				...data.fields,
				transmittal_confirmed_date: dateTime,
				// release_or_paper_released_date: dateTime,
				status: 'review',
				tracking,
			},
		}},
	    meta: { resource: 'accounts', fetch: UPDATE, cancelPrevious: false },
	}
}

export const ACCOUNT_REJECT_TRANSMITTAL = 'ACCOUNT_REJECT_TRANSMITTAL'

export const accountRejectTransmittal = (id, data, dateTime) => {

	const tracking = [
		...(data.fields.tracking || []),
		{
			...trackingDefaults,
			from_status: data.fields.status,
			to_status: 'new',
			date: dateTime,
		}
	]

	return {
	    type: ACCOUNT_REJECT_TRANSMITTAL,
		payload: { id, data: {
			...data,
			fields: {
				...data.fields,
				status: 'new',
				is_transmitted: false,
				tracking,
			},
		}},
	    meta: { resource: 'accounts', fetch: UPDATE, cancelPrevious: false },
	}
}

export const ACCOUNT_BOOK = 'ACCOUNT_BOOK'

export const accountBook = (id, data, basePath) => {

	const tracking = [
		...(data.fields.tracking || []),
		{
			...trackingDefaults,
			from_status: data.fields.status,
			to_status: 'booking',
			date: dateNow(),
		}
	]

	return {
	    type: ACCOUNT_BOOK,
		payload: { id, data: {
			...data,
			fields: {
				...data.fields,
				status: 'booking',
				tracking,
			},
		}},
	    meta: { resource: 'accounts', fetch: UPDATE, cancelPrevious: false },
	}
}

export const ACCOUNT_FOR_COLLECTION = 'ACCOUNT_FOR_COLLECTION'

export const accountForCollection = (id, data, basePath) => {

	const tracking = [
		...(data.fields.tracking || []),
		{
			...trackingDefaults,
			from_status: data.fields.status,
			to_status: 'for_collection',
			date: dateNow(),
		}
	]

	return {
	    type: ACCOUNT_FOR_COLLECTION,
		payload: { id, data: {
			...data,
			fields: {
				...data.fields,
				status: 'for_collection',
				tracking,
			},
		}},
	    meta: { resource: 'accounts', fetch: UPDATE, cancelPrevious: false },
	}
}

export const ACCOUNT_PROCEEDS_COLLECTED = 'ACCOUNT_PROCEEDS_COLLECTED'

export const accountProceedsCollected = (id, data, date = dateNow()) => {

	const tracking = [
		...(data.fields.tracking || []),
		{
			...trackingDefaults,
			from_status: data.fields.status,
			to_status: 'proceeds_collected',
			date: date,
		}
	]

	return {
	    type: ACCOUNT_PROCEEDS_COLLECTED,
		payload: { id, data: {
			...data,
			fields: {
				...data.fields,
				proceeds_collected_date: date,
				status: 'proceeds_collected',
				tracking,
			},
		}},
	    meta: { resource: 'accounts', fetch: UPDATE, cancelPrevious: false },
	}
}

export const ACCOUNT_DI_COLLECTED = 'ACCOUNT_DI_COLLECTED'

export const accountDiCollected = (id, data, date = dateNow()) => {

	const tracking = [
		...(data.fields.tracking || []),
		{
			...trackingDefaults,
			from_status: data.fields.status,
			to_status: 'di_collected',
			date: date,
		}
	]

	return {
	    type: ACCOUNT_DI_COLLECTED,
		payload: { id, data: {
			...data,
			fields: {
				...data.fields,
				di_collected_date: date,
				status: 'di_collected',
				tracking,
			},
		}},
	    meta: { resource: 'accounts', fetch: UPDATE, cancelPrevious: false },
	}
}

export const ACCOUNT_SUBMIT_OR_CR = 'ACCOUNT_SUBMIT_OR_CR'

export const accountSubmitORCR = (id, data, basePath) => {

	return {
	    type: ACCOUNT_SUBMIT_OR_CR,
		payload: { id, data: {
			...data,
			fields: {
				...data.fields,
				or__cr_submission_date: dateNow(),
			},
		}},
	    meta: { resource: 'accounts', fetch: UPDATE, cancelPrevious: false },
	}
}



// WEBPACK FOOTER //
// ./src/actions/AccountActions.js